import { render, staticRenderFns } from "./LinkSection.vue?vue&type=template&id=3152c742&scoped=true&"
import script from "./LinkSection.vue?vue&type=script&lang=js&"
export * from "./LinkSection.vue?vue&type=script&lang=js&"
import style0 from "./LinkSection.vue?vue&type=style&index=0&id=3152c742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3152c742",
  null
  
)

export default component.exports